import React, { ChangeEvent, useState } from 'react'

import Alert from 'components_new/atoms/Alert'
import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Link from 'components_new/atoms/Link'
import TextField from 'components_new/atoms/TextField'

import AuthHero from '../AuthHero'

import { handleEnter, validateRequired } from '../utils'

interface MFAVerifyProps {
  errors: { message: string }[]
  loading: boolean
  onBackToSignIn: () => void
  onVerifyMFA: (code: string) => Promise<void>
  setErrors: (errors: { message: string }[]) => void
}

const MFAVerify = (props: MFAVerifyProps) => {
  const [code, setCode] = useState('')
  const [errorInCode, setErrorInCode] = useState(false)

  const handleChangeCode = (e: ChangeEvent<HTMLInputElement>) => {
    props.setErrors([])
    setErrorInCode(false)
    setCode(e.target.value)
  }

  const handleVerify = async () => {
    const validCode = validateRequired(code)

    if (validCode) {
      await props.onVerifyMFA(code)
    } else {
      setErrorInCode(true)
    }
  }

  return (
    <Box sx={{ minHeight: 500, paddingTop: '96px' }}>
      <AuthHero
        title="Tvåfaktorsautentisering"
        subtitle="Ange verifieringskoden från din autentiseringsapp."
      />
      <Box sx={{ mb: 4, maxWidth: 400 }}>
        <Box sx={{ mb: 2 }}>
          <TextField
            error={errorInCode}
            fullWidth
            helperText={
              errorInCode ? 'Ange verifieringskoden från din app' : undefined
            }
            label={'Verifieringskod'}
            onChange={handleChangeCode}
            onKeyDown={(e) => handleEnter(e, handleVerify)}
            value={code}
            autoFocus
          />
        </Box>
        <Button
          color="brand"
          fullWidth={true}
          loading={props.loading}
          loadingTitle="Verifierar"
          onClick={handleVerify}
          size="large"
        >
          Verifiera
        </Button>
      </Box>
      {props.errors.length > 0 ? (
        <Alert severity={'error'} variant={'outlined'} sx={{ mb: 4 }}>
          {props.errors[0].message}
        </Alert>
      ) : null}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
      >
        <Link onClick={props.onBackToSignIn}>Tillbaka till inloggning</Link>
      </Box>
    </Box>
  )
}

MFAVerify.displayName = 'MFAVerify'

export default MFAVerify
